import Vue from 'vue';
import Slick from 'vue-slick';
import "regenerator-runtime/runtime"; // Required for async functions
import { setContentHeight, insertAfter } from './utils/helpers';
import HeaderSearch from './components/header-search.js';
import Collapsible from './components/collapsible.vue';
import { CollapseTransition } from 'vue2-transitions';
import cartController from './mixins/cartController.js';
import dotDigitalFormController from './mixins/dotDigitalFormController.js';
import CountdownTimer from './components/countdown-timer.vue';

// Uncomment this to suppress Vue warnings in development mode
// Vue.config.silent = true;

export const app = new Vue({
    el: '#app',

    delimiters: ['${', '}'],

    mixins: [ cartController(), dotDigitalFormController() ],
    
    components: {
        Slick,
        HeaderSearch,
        Collapsible,
        CollapseTransition,
        CountdownTimer
    },
    
    directives: {
        initMegamenu: {
            inserted(el, binding, vnode) {
                let dropdown = document.querySelector('[parent-item="' + binding.value + '"]');

                if (!dropdown) {
                    // If no dropdown bind events for normal menu links
                    el.addEventListener('mouseover', () => {
                        if (window.matchMedia("(min-width: 992px)").matches) {
                            vnode.context.closeAllMegamenus();
                        }
                    });

                    // Remove arrows from elements without dropdowns
                    if (el.querySelector('.menu__arrow')) {
                        el.querySelector('.menu__arrow').remove();
                    }
                }
                else if (dropdown) {
                    // Otherwise bind events for dropdowns
                    Vue.set(vnode.context.megamenuToggles, binding.value, false);
    
                    insertAfter(dropdown, el.querySelector('.menu__arrow'));
    
                    // Dropdowns
                    el.addEventListener('mouseleave', () => {
                        // When leaving the parent LI close everything
                        if (window.matchMedia("(min-width: 992px)").matches) {
                            vnode.context.closeAllMegamenus();
                        }
                    });
                    el.addEventListener('mouseover', () => {
                        // When entering the parent LI open this dropdown and close the others
                        if (window.matchMedia("(min-width: 992px)").matches) {
                            vnode.context.toggleMegamenu(binding.value, true);
                        }
                    });
                    
                    // Mobile
                    el.querySelector('.menu__arrow').addEventListener('click', (e) => {
                        // On click arrow, but not main title/link, so both work as current site
                        if (window.matchMedia("(max-width: 991px)").matches) {
                            e.preventDefault();
                            vnode.context.toggleMegamenu(binding.value);
                        }
                    });
    
                } 
            }
        }
    },

    data: {
        isMenuOpen: false,
        megamenuToggles: {},
        isSearchOpen: false,
        isMobile: window.innerWidth <= 767,
        cartMessage: {
            show: false,
            message: "Products Added to Cart",
            type: "success"
        },
    },

    watch: {
        isMenuOpen(value) {
            if (value) {
                document.querySelector('body').classList.add('no-scroll');
            } else {
                document.querySelector('body').classList.remove('no-scroll');
            }
        }
    },

    created() {
        this.getCart();
    },


    mounted() {
        // Hide content until header has loaded
        document.querySelector('body').classList.remove('d-none');

        // Fix for iOS Safari 100vh issue
        setContentHeight();
        window.addEventListener('resize', () => setContentHeight());

        console.log('Vue app mounted. V2');
    },

    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
            this.isSearchOpen = false;
            this.isMinicartOpen = false;
            this.closeAllMegamenus();
        },

        toggleMegamenu(parent, forceTrue = false) {
            let toggle = forceTrue ? true : !this.megamenuToggles[parent];
            this.megamenuToggles[parent] = toggle;

            for (let menu in this.megamenuToggles) {
                if (menu != parent) this.megamenuToggles[menu] = false;
            };
        },

        closeAllMegamenus() {
            for (let menu in this.megamenuToggles) {
                this.megamenuToggles[menu] = false;
            }
        },

        toggleSearch() {
            this.isSearchOpen = !this.isSearchOpen;
            this.isMinicartOpen = false;
            this.isMenuOpen = false;
            this.closeAllMegamenus();

            if (this.isSearchOpen && this.$refs.search) {
                this.$nextTick(() => {
                    this.$refs.search.select();
                });
            }
        }
    }
});